import { render, staticRenderFns } from "./WishlistModal.vue?vue&type=template&id=99e29d76&scoped=true&"
import script from "./WishlistModal.vue?vue&type=script&lang=js&"
export * from "./WishlistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e29d76",
  null
  
)

export default component.exports